@if (!_isSingleOption) {
    <lg-icon-menu
        [definition]="_menuDefinition"
        (currentChange)="_onMenuSelect($event)"
        icon="icon-copy"
        [class]="iconClass"
        [tooltip]="'FW._Directives.CopyButton_Tooltip' | lgTranslate"
    />
}

@if (_isSingleOption) {
    <lg-icon
        icon="icon-copy"
        class="lg-panel__header-icon"
        [clickable]="true"
        (click)="_copyFirst()"
        [lgTooltip]="'FW._Directives.CopyButton_Tooltip' | lgTranslate"
    />
}
